// Shared helpers for naming downloaded image files.
//
// The blob's mime type is the authoritative source. Every call site fetches
// through /api/proxy-image, which defaults a missing Content-Type to
// image/jpeg, so the mime type is never truly absent; the URL extension is
// consulted only when that type is generic or unrecognised
// (e.g. application/octet-stream).

const MIME_EXTENSIONS = {
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/tiff': 'tiff',
  'image/bmp': 'bmp',
  'image/svg+xml': 'svg',
  'image/avif': 'avif',
};

const URL_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'tiff', 'tif', 'bmp', 'svg', 'avif'];

export function extensionFor(mimeType, url) {
  const bare = (mimeType || '').split(';')[0].trim().toLowerCase();
  if (MIME_EXTENSIONS[bare]) return MIME_EXTENSIONS[bare];

  if (url) {
    const path = url.split(/[?#]/)[0];
    const lastDot = path.lastIndexOf('.');
    const lastSlash = path.lastIndexOf('/');
    if (lastDot > lastSlash) {
      const ext = path.slice(lastDot + 1).toLowerCase();
      if (URL_EXTENSIONS.includes(ext)) return ext === 'jpeg' ? 'jpg' : ext;
    }
  }

  return 'jpg';
}

// Basenames Windows refuses to write, with or without an extension.
const WINDOWS_RESERVED = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/i;

export function safeFilename(title, extension) {
  // Combining marks are \p{M}, not \p{L}: scripts such as Devanagari, Tamil,
  // Bengali, Hebrew niqqud and Arabic harakat have no precomposed form, so
  // excluding \p{M} would inject underscores mid-word rather than merely drop
  // accents. NFC first so visually identical titles yield byte-identical names
  // (macOS hands back NFD from the filesystem).
  // Array.from before slicing so a surrogate pair is never split mid-character.
  const base = Array.from((title || '').normalize('NFC').replace(/[^\p{L}\p{M}\p{N}]+/gu, '_'))
    .slice(0, 50).join('')
    .replace(/^_+|_+$/g, '');
  if (WINDOWS_RESERVED.test(base)) return `image_${base}.${extension}`;
  return `${base || 'image'}.${extension}`;
}
